import request from '@/utils/request.js'



/*****批量删除卡片列表******/
export function deleteCardInBatchesList(data){
    return request({
        url: '/sim/batch/delete/list',
        method: 'post',
        data
    })
}
